import ModelActionsService from 'services/storageModelActions/ModelActionsService';
import { CallResponseDTO, CreateCallRequestDTO } from 'typings/dto/call';
import IModelActionsService from './IModelActionsService';

export default class CallActionsService
  extends ModelActionsService<Call, CreateCallRequestDTO, CallResponseDTO>
  implements IModelActionsService<Call, CreateCallRequestDTO, CallResponseDTO> {}
